// for defining icon associations for dynamically-generated content
//@todo: This should probably be in the individual Dealer Access Client repos for each division, since it depends on category IDs from their respective CMSes.
export const iconMap = {
    categories: {
        'fe5672f8-a8f9-44f4-a592-9e00cc89d260': {
            label: 'parts',
            glyph: 'nut-fill',
            src: null,
        },
        'e04ae47c-5233-44ab-ab11-4230b3a3373f': {
            label: 'credit',
            glyph: 'credit-card',
            src: null,
        },
        '9f1cefcd-2e8e-4872-a072-b64031be9e42': {
            label: 'government_fleet_contracts',
            glyph: 'bank',
            src: null,
        },
        'd080c98b-1742-4067-926b-10194a39e829': {
            label: 'sales_marketing',
            glyph: 'bar-chart-fill',
            src: null,
        },
        '8104e9e3-9e51-480c-8d7c-576aa885656a': {
            label: 'service',
            glyph: 'tools',
            src: null,
        },
        '69fd55a3-17ca-431b-86ce-629d33186509': {
            label: 'warranty',
            glyph: 'card-checklist',
            src: null,
        },
        '2f79b6d9-69d3-44ab-b659-18d1f3d6e8b6': {
            label: 'wholegoods',
            glyph: 'box-fill',
            src: null,
        },
        'e10ab9fe-e4b1-4524-8379-d0901ba3ec7f': {
            label: 'playbook',
            glyph: 'journals',
            src: null,
        },
        'ac9d3819-2268-44cb-bff1-5a3504123786': {
            label: 'helpful links',
            glyph: 'link-45deg',
            src: null,
        },
        'c106f99c-fc30-4291-97b0-a4a9881b4a4e': {
            label: 'training',
            glyph: 'mortarboard-fill',
            src: null,
        },
        'e8d713ac-2a27-4dae-aac8-4a246e043b6a': {
            label: 'dealers',
            glyph: 'people-fill',
            src: null,
        },
        '34b1d2a0-14c4-4057-bfb8-04b37d4b5cf3': {
            label: 'parts & service',
            glyph: 'tools',
            src: null,
        },
        '0b7acbf0-12aa-4826-8248-df53fc150749': {
            label: 'sales',
            glyph: 'bar-chart-fill',
            src: null,
        },
        'da9ae1e5-8580-4d9d-8289-0df05b7ad87e': {
            label: 'wholegoods',
            glyph: 'box-fill',
            src: null,
        },
        // TM Category
        '0d53d3c4-393e-4745-bc81-93cc4e727ab4': {
            label: 'Credit',
            glyph: 'credit-card',
            src: null,
        },
    }
};
